import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import * as actions from "../../../../actions/project.actions";
import * as commonActions from "../../../../actions/common.actions";
import * as projectActions from "../../../../actions/project.actions";
import * as userActions from "../../../../actions/user.actions";

import MemberProfile from "../components/memberProfile";
import CompleteProjectModal from "../../../common/completeProjectModal/CompleteProjectModal";
import declineModal from "../components/declineModal";
import hireModal from "../components/hireModal";
import acceptModal from "../../memberProposal/components/acceptModal";
import requestEditModal from "../../memberProposal/components/requestEditModal";

const subHeader = (memberId, pitchId, projectId) => {
  return {
    items: [
      {
        caption: "Member Profile",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/memberProfile`
      },
      {
        caption: "Statement of Work",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/sow`
      },
      {
        caption: "Messages",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/messages`
      }
    ],
    activeItem: 0
  };
};

const pitchPending = (hireMember, declineMember, urlMessages) => ({
  color: "blue",
  title: "This Member Has Pitched Your Project",
  text: (
    <span>
      Click <Link to={urlMessages}>Messages</Link> to communicate with this
      member directly. Click Hire to decline all other member pitches and move
      this member to the Statement of Work phase.
    </span>
  ),
  buttons: [
    {
      text: "Decline",
      type: "modalTrigger",
      modal: declineModal,
      modalClick: declineMember
    },
    {
      text: "Hire",
      type: "modalTrigger",
      color: "blue",
      modal: hireModal,
      modalClick: hireMember
    }
  ]
});

const awaitingSow = memberName => ({
  color: "blue",
  title: `You have selected ${memberName}`,
  text: `We have alerted her to submit her SOW for this project.
    When she completes it, we will notify you by email.`
});

// const sowEdisRequestedHeaderBar = () => ({
//   center: true,
//   color: 'grey',
//   title: 'The Member has been notified that you requested modifications. '
// });

const pitchDeclined = () => ({
  center: false,
  color: "grey",
  title: "The Pitch is Declined",
  text: "You declined this pitch"
});

const sowPendingApprovalHeaderBar = (acceptSow, requestEdit) => ({
  color: "blue",
  title: "SOW in Draft",
  text: `The Member has submitted the SOW below. If it’s ready, hit “Accept”.
  Otherwise, hit “Request Edits” to message her about changes.`,
  buttons: [
    {
      text: "Request Edits",
      type: "modalTrigger",
      color: "blue",
      modal: requestEditModal,
      modalClick: requestEdit
    },
    {
      text: "Accept",
      type: "modalTrigger",
      modal: acceptModal,
      modalClick: acceptSow
    }
  ]
});

const sowApprovedHeaderBar = (completeProject, projectId) => ({
  center: false,
  color: "grey",
  title: "Your Project is Underway",
  text: `After you’ve completed the project,
   click the button on the right to kick off the invoicing and review process.`,
  buttons: [
    {
      text: "Complete Project",
      type: "modalTrigger",
      modalProps: {
        completeProject,
        projectId
      },
      modal: CompleteProjectModal
    }
  ]
});

const projectCompletedHeaderBar = completeProject => ({
  center: false,
  color: "grey",
  title: "The project has been completed.",
  buttons: [
    {
      text: "Submit Feedback",
      onClick: completeProject
    }
  ]
});

class MemberProfileContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentMemberProjectState: null,
      sow: null,
      member: null
    };

    this.acceptSow = this.acceptSow.bind(this);
    this.completeProject = this.completeProject.bind(this);
    this.declineMember = this.declineMember.bind(this);
    this.downloadResume = this.downloadResume.bind(this);
    this.hireMember = this.hireMember.bind(this);
    this.requestEdit = this.requestEdit.bind(this);
    this.setHeaderBar = this.setHeaderBar.bind(this);
  }

  componentDidMount() {
    const { memberId, pitchId, projectId } = this.props.match.params;

    this.props.actions.getMember(memberId);
    this.props.actions.getPitch(pitchId);
    this.props.actions.getProject(projectId);

    this.props.commonActions.setSubHeader(
      subHeader(memberId, pitchId, projectId)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevProps, prevState);
    this.setMemberName();
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  setHeaderBar(prevProps, prevState) {
    if (!_.isEmpty(this.props.pitch) && this.props.pitch !== prevProps.pitch) {
      const member = this.props.member;
      const pitch = this.props.pitch;
      const sow = _.get(pitch, "sow");

      const pitchAccepted = _.get(pitch, "accepted");
      const sowPendingApproval = pitchAccepted && sow;
      const sowApproved = _.get(sow, "accepted");

      let headerBar = {};
      let currentEmployerProjectState = null;

      if (sowApproved) {
        // SOW Approved
        currentEmployerProjectState = "sowApproved";

        if (this.props.project) {
          switch (this.props.project.status.name) {
            case "completed":
              headerBar = projectCompletedHeaderBar(this.completeProject);
              break;

            case "reviewed":
              break;

            default:
              headerBar = sowApprovedHeaderBar(this.completeProject);
              break;
          }
        } else {
          headerBar = sowApprovedHeaderBar(this.completeProject);
        }
      } else if (sowPendingApproval) {
        //Awaiting for employer to approved the SOW
        currentEmployerProjectState = "sowPendingApproval";
        headerBar = sowPendingApprovalHeaderBar(
          this.acceptSow,
          this.requestEdit
        );
      } else if (pitchAccepted) {
        //Awaiting for member to send the SOW
        currentEmployerProjectState = "pitchAccepted";
        headerBar = awaitingSow(_.get(member, "first_name"));
      } else if (pitchAccepted === false) {
        currentEmployerProjectState = "pitchDeclined";
        headerBar = pitchDeclined();
      } else if (pitchAccepted === null) {
        //Pitch Pending
        currentEmployerProjectState = "pitchPending";

        const pitchId = this.props.pitch.id;
        const memberId = this.props.member.id;
        const projectId = this.props.pitch.match.project.id;
        const urlMessages = `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/messages`;

        headerBar = pitchPending(
          this.hireMember,
          this.declineMember,
          urlMessages
        );
      }

      if (
        currentEmployerProjectState !== prevState.currentEmployerProjectState ||
        sow !== prevState.sow
      ) {
        this.props.commonActions.setHeaderBar(headerBar);
        this.setState({ currentEmployerProjectState, sow, member });
      }
    }
  }

  setMemberName() {
    const { member } = this.state;

    if (member) {
      localStorage.setItem(
        "candidateName",
        member.first_name + " " + member.last_name
      );
    }
  }

  acceptSow() {
    const payload = {
      sow_id: this.state.sow.id,
      accepted: true
    };

    this.props.actions.acceptSow(payload, this.props.pitch.id);
  }

  completeProject() {
    this.props.projectActions.completeProjectByEmployer(
      this.props.project.id,
      this.props.member.id
    );
  }

  declineMember(message) {
    const payload = {
      pitch_id: this.props.pitch.id,
      message: message,
      accept: false
    };
    this.props.projectActions.acceptPitch(payload);
  }

  downloadResume(e) {
    e.preventDefault();

    // Flag to know if we need to download the resume or just view (open) it
    const download = e.target.dataset.download === "true";

    if (this.props.match.params.memberId) {
      this.props.userActions.downloadResume(
        this.props.match.params.memberId,
        download
      );
    }
  }

  hireMember() {
    const payload = {
      pitch_id: this.props.pitch.id,
      accept: true
    };
    this.props.actions.acceptPitch(payload);
  }

  requestEdit(message) {
    const payload = {
      sow_id: this.state.sow.id,
      edits_requested: true,
      message
    };

    this.props.actions.acceptSow(payload, this.props.pitch.id);
  }

  render() {
    const member = this.props.member || {};
    const pitch = this.props.pitch || {};

    return (
      <MemberProfile
        memberData={member}
        pitchData={pitch}
        downloadResume={this.downloadResume}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    member: state.project.member,
    pitch: state.project.pitch,
    project: state.project.data.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberProfileContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/memberProfile/container/memberProfileContainer.js